// extracted by mini-css-extract-plugin
module.exports = {"mapMain":"Map_mapMain__NrkId","Our_Img":"Map_Our_Img__UsiIY","mapContent":"Map_mapContent__3qsoP","mapHistory":"Map_mapHistory__xgIFI"};